import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import { mapChildrenIndexedByType } from "../../helper/map-children";
import { useUniqueId } from "../hooks/useUniqueId";

import { CheckboxGroupProvider } from "./CheckboxGroupContext";

import styles from "./Checkbox.scss";

function CheckboxGroup(props) {
  const { children, variants, customClass, ...restProps } = props;
  const { id } = restProps;
  const checkboxGroupId = id || useUniqueId("CheckboxGroup", props) + 1;

  return (
    <fieldset
      className={cx(styles.fieldset, variants, customClass)}
      {...restProps}
    >
      {mapChildrenIndexedByType(children, (child, childIndexByType) => {
        return (
          <CheckboxGroupProvider
            value={{ id: checkboxGroupId, checkboxIndex: childIndexByType + 1 }}
          >
            {child}
          </CheckboxGroupProvider>
        );
      })}
    </fieldset>
  );
}

CheckboxGroup.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  variants: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  customClass: PropTypes.string,
};

CheckboxGroup.defaultProps = {
  variants: "",
  customClass: undefined,
};

CheckboxGroup.Variant = {
  block: styles.groupBlock,
};

CheckboxGroup.displayName = "Checkbox.Group";

export default CheckboxGroup;
